var map = {
	"./adult/nn/2 7 Ordkjedetest-Starter-testen.mp3": 760,
	"./adult/no/2 7 Ordkjedetest-Starter-testen.mp3": 761,
	"./child/de/2 7 Ordkjedetest-Starter-testen.mp3": 762,
	"./youth/de/2 7 Ordkjedetest-Starter-testen.mp3": 763,
	"./youth/nn/2 7 Ordkjedetest-Starter-testen.mp3": 764,
	"./youth/no/2 7 Ordkjedetest-Starter-testen.mp3": 765,
	"./youth/se/2 7 Ordkjedetest-Starter-testen.mp3": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;